/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

type Props = {
  title?: React.ReactNode;
  children: React.ReactNode;
  spacing?: number;
};

const styles = {
  subsection: (theme: Theme, spacing?: number) => css`
    padding: ${spacing ? `${spacing}px` : theme.spacing(16)} 0 ${theme.spacing(16)};
  `,
  subsectionTitle: (theme: Theme) => css`
    padding: ${theme.spacing(0, 0, 16, 0)};
  `,
};

const Subsection = ({ title, children, spacing }: Props) => {
  const theme = useTheme();
  return (
    <div css={styles.subsection(theme, spacing)}>
      {title && <div css={styles.subsectionTitle}>{title}</div>}
      {children}
    </div>
  );
};

export default Subsection;
